import { useContext } from "react";
import {
	getCompareCompanyNameOverrides,
	getContentfulCompanies,
	getDeemphasizedCompanyVisitSlugOverrides,
} from "@/selectors";
import { useSelector } from "react-redux";

import { CompanyContext } from "../components/CompanyList/CompanyContext";

const DEEMPHASIZED_LINK_PARAMS = { plc: "deemphasized_redirect" };

export const useDeemphasizedCompany = () => {
	const { company } = useContext(CompanyContext);
	const deemphasizedCompanyVisitSlugOverrides = useSelector(
		getDeemphasizedCompanyVisitSlugOverrides,
	);
	const compareCompanyNameOverrides = useSelector(
		getCompareCompanyNameOverrides,
	);
	const contentfulCompanies = useSelector(getContentfulCompanies);

	const isDeemphasizedCompany = Object.hasOwn(
		deemphasizedCompanyVisitSlugOverrides,
		company.fields.companySlug,
	);

	if (!isDeemphasizedCompany) {
		return {
			isDeemphasizedCompany,
			compareCompanyName: undefined,
			deemphasizedLinkParams: undefined,
		};
	}

	const compareCompanySlug =
		deemphasizedCompanyVisitSlugOverrides[company.fields.companySlug];
	const compareCompanyName =
		compareCompanyNameOverrides[compareCompanySlug] ??
		contentfulCompanies.find(
			(candidate) => candidate.fields.companySlug === compareCompanySlug,
		)?.fields.companyName;

	return {
		isDeemphasizedCompany,
		compareCompanyName,
		deemphasizedLinkParams: DEEMPHASIZED_LINK_PARAMS,
	};
};
